// src/widgets/components/FullPageConversation.tsx
import { Box } from '@chakra-ui/react';
import { WidgetConfig } from '../types/config';
import { useEffect, useState } from 'react';
import { WhatsAppEventsProvider } from '@/context/whatsapp-events-context';
import { ConversationsProvider } from '@/context/conversation-context';
import ConversationsPage from '@/pages/conversations/conversations-page';

interface FullPageProps {
  config: WidgetConfig;
}

function FullPageConversation({ config }: FullPageProps) {
  console.log('FullPageConversation [WIDGET]');
  const [viewportHeight, setViewportHeight] = useState<number>(
    window.innerHeight,
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        setViewportHeight(window.visualViewport.height);
      } else {
        setViewportHeight(window.innerHeight);
      }
    };

    // Prevent background scrolling when in fullscreen mode
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
      window.visualViewport.addEventListener('scroll', handleResize);
    } else {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      // Restore scrolling when unmounted
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleResize);
        window.visualViewport.removeEventListener('scroll', handleResize);
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      width="100vw"
      height={`${viewportHeight}px`}
      bg="white"
      zIndex={9999}
      overflow="hidden"
      display="flex"
      flexDirection="column"
      className="conversations-widget-fullpage"
    >
      <WhatsAppEventsProvider
        wsUrl={config.apiHost + '/ws'}
        reconnectMaxAttempts={10}
        initialReconnectDelay={1000}
        maxReconnectDelay={30000}
      >
        <ConversationsProvider>
          <ConversationsPage
            hideConversationList={config.hideConversationList}
            hideHeader={config.hideHeader}
            userPhone={config.userPhone}
            userFirstName={config.userFirstName}
            userLastName={config.userLastName}
            userMember={config.userMember}
          />
        </ConversationsProvider>
      </WhatsAppEventsProvider>
    </Box>
  );
}

export default FullPageConversation;
